export default __webpack_public_path__ + "static/media/0065.84af4de7.png";